import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/catch";
import {codigoGTMConsultado} from "./actions";
import {catchError, map, mergeMap} from "rxjs/operators";
import * as types from "./types";
import {ofType} from "redux-observable";
import {RequestWrapper} from "../../../request/RequestWrapper/RequestWrapper";

export const consultarCodigoGTMEpic = action$ =>
  action$.pipe(
    ofType(types.CONSULTAR_CODIGO_GTM),
    mergeMap(() => RequestWrapper
      .get("/gestion-contenido-empresarial/api/recepcion-documental/seguridad/gtm")
      .pipe(
        map(response => codigoGTMConsultado(response)),
        catchError((error) => [{type: types.ERROR_CONSULTANDO_CODIGO_GTM, error: error}])
      )
    )
  );
